<template lang="pug">
    .menu-nav(v-if="category")
        .menu-nav__slider(v-if='windowWidth < 1200')
            .swiper-container
                .swiper-wrapper
                    .swiper-slide(v-for="item in category" :key="item.id")
                        .menu-nav__slider-item
                            router-link(:to="item.link" exact) {{item.name}}
                .swiper-button-next--wr
                .swiper-button-next
                    SvgIcon(name="arrow" width="16" height="28")
                .swiper-button-prev--wr
                .swiper-button-prev
                    SvgIcon(name="arrow" width="16" height="28")
        .menu-nav__list(v-else)
            .menu-nav__slider-item(v-for="item in category" :key="item.id")
                SvgIcon.menu-nav__slider-item-leaf(name="leaf" )
                router-link(:to="item.link" exact) {{item.name}}
                svg.menu-nav__slider-item-line(width="121" height="16" viewBox="0 0 121 16" fill="none" xmlns="http://www.w3.org/2000/svg")
                    path(d="M2.73739 12.6919C2.73739 12.6919 -1.48201 6.84408 29.5152 6.19596C60.5125 5.54783 118 9.49999 118 9.49999" stroke="#505050" stroke-width="4" stroke-linecap="round")
</template>

<script>
    import '@/components/common/menuNav/menuNav.styl';

    import EventBus from '@/eventBus';

    import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
    import {SliderHelpersVue} from "@/mixins/SliderHelpersVue";

    export default {
        name: 'MenuNav',

        mixins: [SliderHelpersVue],

        data() {
            return {
                swiper: null,
                currentLink: '',
                windowWidth: 0,
                svg: null,
                event: false
            }
        },

        props: [
            'category'
        ],

        components: {
            SvgIcon
        },

        created() {
            this.windowWidth = $(window).width();
            this.currentLink = this.$router.currentRoute.path;
            this.$nextTick(() => {
                if($('.menu-nav__slider').length) {
                    let sliderParams = {
                        slidesPerView: 'auto',
                        autoplay: false
                    };
                    this.swiper = this.initSlider('.menu-nav__slider', sliderParams);
                    this.addActiveMobile();
                } else {
                    let size, number;

                    if(this.windowWidth >= 1600) {
                        size = 30;
                        number = 110;
                    } else {
                        size = 10;
                        number = 120;
                        $('.menu-nav__slider-item-line').attr('height', '12');
                    }

                    $('.menu-nav__slider-item-line').each((index) => {
                        let elem = $($('.menu-nav__slider-item-line')[index]),
                            parentWidth = elem.parent().width(),
                            path, pathArray, value;

                        elem.attr('width', parentWidth + size + 'px');
                        path = elem.find('path').attr('d');
                        pathArray = path.split(' ');
                        pathArray[pathArray.length - 2] = parentWidth * (number * 0.0095);
                        elem.find('path').attr('d', pathArray.join(' '));

                        if(this.windowWidth > 1600) {
                            value = parentWidth * (parentWidth * 0.0001) + ' ' + 0 + ' ' + parentWidth + size + ' 16';
                        } else {
                            value = parentWidth * (parentWidth * 0.0001) + ' ' + 0 + ' ' + (parentWidth + size + 5) + ' 16';
                        }

                        elem.attr('viewBox', value);
                    });

                    this.svg = $('.menu-nav__slider-item-line').drawsvg({
                        duration: 500
                    });

                    if(this.event === true) {
                        setTimeout(() => {
                            $('.menu-nav__slider-item').find('.router-link-active').parent().addClass('menu-nav__slider-item--active');
                            this.svg.drawsvg('animate');
                            this.event = false;
                        }, 200);
                    }
                }
            });

            EventBus.$on('changeMenuCategory', () => {
                $('.menu-nav__slider-item').removeClass('menu-nav__slider-item--active');
                if(this.windowWidth < 1200) {
                    setTimeout(() => {
                        $('.menu-nav__slider-item').find('.router-link-active').parent().addClass('menu-nav__slider-item--active');
                    }, 200);
                } else {
                    this.addActive();
                }
            });

            EventBus.$on('addMenuCategory', () => {
                $('.menu-nav__slider-item').removeClass('menu-nav__slider-item--active');
                if(this.windowWidth < 1200) {
                    this.currentLink = this.$router.currentRoute.path;
                    this.addActiveMobile();
                } else {
                    this.addActive();
                }
            });

            EventBus.$on('pushMenuPage', () => {
                if(this.windowWidth < 1200) {
                    this.swiper.slideTo(0, 300, false);
                }
            });
        },

        mounted() {

        },

        methods: {
            scrollToActive() {
                let links = $('.menu-nav__slider-item > a');
                let href = links.map((index, link) => {
                    return $(link).attr('href');
                });
                let index = 0;
                for(let i = 0; i < this.swiper.slides.length; i++) {
                    if(href[i] == this.currentLink) {
                        index = i;
                        break;
                    }
                }
                if(index !== 0) {
                    this.swiper.slideTo(index - 1, 300, false);
                }
            },
            addActive() {
                if (this.svg) {
                    setTimeout(() => {
                        $('.menu-nav__slider-item').find('.router-link-active').parent().addClass('menu-nav__slider-item--active');
                        this.svg.drawsvg('animate');
                        setTimeout(() => {
                            $('html').animate({
                                scrollTop: 0
                            }, 500);
                        }, 300);
                    }, 200);
                } else {
                    this.event = true;
                }
            },
            addActiveMobile() {
                setTimeout(() => {
                    $('.menu-nav__slider-item').find('.router-link-active').parent().addClass('menu-nav__slider-item--active');
                    this.scrollToActive();
                }, 200);
            }
        }

    }
</script>
